import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import IconLoader from "@/features/Common/components/IconLoader";
import Panel from "@/features/Common/components/Panel";
import theme from "@/theme";
import { convertPxToRem } from "@/utils";
import { Divider, Stack, Typography } from "@mui/material";
import { Pagination } from "swiper/modules";

export interface CardData {
  title: string;
  description: string;
  iconName: string;
}
interface ScrollCardsProps {
  cardsData: CardData[];
}

export function ScrollCards({ cardsData }: ScrollCardsProps) {
  return (
    <Swiper
      modules={[Pagination]}
      pagination={{ clickable: true }}
      spaceBetween={10}
      slidesPerView={1}
      style={{
        paddingBottom: convertPxToRem(30),
        paddingLeft: convertPxToRem(6),
        paddingRight: convertPxToRem(6),
        paddingTop: convertPxToRem(8),
        background: theme.palette.background.paper,
      }}
    >
      {cardsData.map((item) => (
        <SwiperSlide key={item.title}>
          <Panel>
            <Stack flexDirection="row" spacing={3}>
              <Stack flex={1}>
                <IconLoader
                  icon={item.iconName}
                  color="primary"
                  sx={{
                    fontSize: theme.spacing(10),
                    alignSelf: "center",
                  }}
                />
              </Stack>

              <Divider
                orientation={"vertical"}
                flexItem
                style={{ marginTop: 0 }}
              />

              <Stack
                spacing={1}
                flex={2}
                pl={2}
                style={{ marginTop: 0 }}
                sx={{ alignSelf: "center" }}
              >
                <Typography variant="h4">{item.title}</Typography>
                <Typography variant="body2">{item.description}</Typography>
              </Stack>
            </Stack>
          </Panel>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
